/* eslint complexity: ["error", 40] */

import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { Button, Container, Fade, Form, Tab, Tabs, ToggleButton, ToggleButtonGroup, Modal } from 'react-bootstrap';
import CommonMetaTag from './common-meta-tag';
import Dialog from 'react-bootstrap-dialog';
import { FaChartBar, FaDatabase, FaDownload, FaFilm, FaFilter, FaFolder, FaFolderPlus, FaHandshake, FaMagic, FaMapMarkerAlt, FaPlus, FaShareAlt, FaShieldAlt, FaTag, FaTimes, FaTrashAlt } from 'react-icons/fa';
import { AiOutlineClockCircle, AiOutlineCalendar } from 'react-icons/ai';
import { Formik } from 'formik';
import PartnerHighLight from './partner-highlight';
import PlayerHighLight from './player-highlight';
import VideoAnalysisSection from './video-analysis-section';
import PartnerVideoSharing from './partner-video-sharing';
import { sharingType } from '../constants';
import downloadIcon from '../images/download_icon.svg';
import editIcon from '../images/edit_icon.svg';
import binIcon from '../images/bin_icon.svg';
import privateIcon from '../images/user_icon_private_red.svg';
import publicIcon from '../images/user_icon_public_red.svg';
import replayerIcon from '../images/user_icon_replayer_red.svg';
import Configuration from '../config';
import playArrowWhite from '../images/play_arrow_white_48dp.png';
import replayerlogoBianco from '../images/replayer_logo_bianco_40x32px.png';
import noLogo from '../images/club_icon_grey.svg';
import { useTranslation, Trans } from 'react-i18next';
import PartnerTags from './partner-tags';
import PartnerVideoTagging from './partner-video-tagging';
import { FilePond } from 'react-filepond';
import { imageTypes } from '../constants';
import 'filepond/dist/filepond.min.css';
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import defaultAvatar from '../images/Replayer_default_Avatar.png'
import {isPickleballVideo} from '../util/video-sports';

const PartnerVideo = ({
  token,
  profile,
  permanentVideos,
  storagePrices,
  selectVideoForHighlight,
  selectVideoForAnalysis,
  selectedPermanentVideo,
  deletePartnerPermanentVideo,
  deletePlaylist,
  modifyPartnerPermanentVideo,
  modifyPlaylist,
  showVideosSharing,
  showPartnerTags,
  userTags,
  myVideoActiveTab,
  setActiveTab,
  showVideoTagging,
  selectedVideoForTagging,
  searchTaggedVideo,
  taggedUserVideos,
  changeStorageType,
  isStorageModalVisible,
  hideStorageModal,
  showStorageModal,
  highlightFolders,
  videoFolders,
  getPartnerHighlightFolders,
  createPartnerHighlightFolder,
  deletePartnerHighlightFolder,
  movePartnerHighlightToFolder,
  getPartnerVideoFolders,
  createPartnerVideoFolder,
  deletePartnerVideoFolder,
  movePartnerVideoToFolder,
  createHighlightPlaylist,
  exportPlaylist,
  isPartnerVideoCreationVisible,
  hidePartnerVideoCreationModal,
  showPartnerVideoCreationModal,
  playlists,
  createPartnerVideo,
  deletePartnerVideo,
  partnerVideos,
  showPartnerVideoEditModal,
  hidePartnerVideoEditModal,
  isPartnerVideoEditModalVisible,
  selectedPartnerVideo,
  editPartnerVideo,
  removeFile,
  showPlayersModal,
  hidePlayersModal,
  isPlayersModalVisible,
  searchPlayers,
  playersList,
  goto,
  showVideosStorePartner,
  sendUsageData,
}) => {
  const [value, setValue] = useState([]);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [selectedPlayer, setSelectedPlayer] = useState({});
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [activeHighlightFolderId, setActiveHighlightFolderId] = useState('all');
  const [activeVideoFolderId, setActiveVideoFolderId] = useState('all');
  const [newHighlightFolderName, setNewHighlightFolderName] = useState('');
  const [newVideoFolderName, setNewVideoFolderName] = useState('');
  const [pendingHighlightFolderName, setPendingHighlightFolderName] = useState(null);
  const [pendingVideoFolderName, setPendingVideoFolderName] = useState(null);
  const [isHighlightGuideModalVisible, setHighlightGuideModalVisible] = useState(false);
  const [isVideoGuideModalVisible, setVideoGuideModalVisible] = useState(false);
  const [selectedHighlightIds, setSelectedHighlightIds] = useState([]);
  const [selectedHighlightCameraIds, setSelectedHighlightCameraIds] = useState({});
  const [isHighlightPlaylistModalVisible, setHighlightPlaylistModalVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, scrollPosition);
  });

  useEffect(() => {
    getPartnerHighlightFolders();
    getPartnerVideoFolders();
  }, [getPartnerHighlightFolders, getPartnerVideoFolders]);

  useEffect(() => {
    if (!pendingHighlightFolderName) {
      return;
    }
    const createdFolder = highlightFolders.find(folder => folder.name === pendingHighlightFolderName);
    if (createdFolder) {
      setActiveHighlightFolderId(String(createdFolder.id));
      setPendingHighlightFolderName(null);
    }
  }, [highlightFolders, pendingHighlightFolderName]);

  useEffect(() => {
    if (!pendingVideoFolderName) {
      return;
    }
    const createdFolder = videoFolders.find(folder => folder.name === pendingVideoFolderName);
    if (createdFolder) {
      setActiveVideoFolderId(String(createdFolder.id));
      setPendingVideoFolderName(null);
    }
  }, [videoFolders, pendingVideoFolderName]);

  const { t, i18n } = useTranslation();
  if (token === null) {
    return (
      <Redirect to="/login" />
    );
  }

  const getScrollPage = () => {
    let docScrollTop = 0;
    if (document.documentElement && document.documentElement !== null) {
      docScrollTop = document.documentElement.scrollTop;
    }
    return window.pageYOffset || docScrollTop;
  };

  let dialog = null;
  const confirmDeleteVideo = videoId => () => {
    dialog.show({
      title: t('CONFIRM_DELETE_VIDEO'),
      body: t('CONFIRM_DELETE_VIDEO_DESC'),
      actions: [
        Dialog.Action(
          t('YES'),
          () => deletePartnerPermanentVideo(videoId),
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('CANCEL'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const confirmDeletePartnerVideo = videoId => () => {
    dialog.show({
      title: t('CONFIRM_DELETE_VIDEO'),
      body: <Trans i18nKey='CONFIRM_DELETE_PARTNER_VIDEO_DESC' />,
      actions: [
        Dialog.Action(
          t('YES'),
          () => deletePartnerVideo(videoId),
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('CANCEL'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const confirmDeletePlaylist = playlistId => () => {
    dialog.show({
      title: t('CONFIRM_DELETE_VIDEO'),
      body: t('CONFIRM_DELETE_VIDEO_DESC'),
      actions: [
        Dialog.Action(
          t('YES'),
          () => deletePlaylist(playlistId),
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('CANCEL'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const safeDownloadFilename = name => {
    const baseName = String(name || 'playlist')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
    return `${baseName || 'playlist'}.mp4`;
  };

  const playlistDownloadUrl = playlist => {
    const downloadUrl = playlist.exportDownloadUrl;
    if (!downloadUrl || /\.mp4(?:\?|$)/i.test(downloadUrl)) {
      return downloadUrl;
    }

    const separator = downloadUrl.endsWith('/') ? '' : '/';
    return `${downloadUrl}${separator}${safeDownloadFilename(playlist.name)}`;
  };

  const downloadPlaylistExport = playlist => event => {
    event.preventDefault();
    if (!playlist.exportDownloadUrl) {
      return;
    }

    const link = document.createElement('a');
    link.href = playlistDownloadUrl(playlist);
    link.download = safeDownloadFilename(playlist.name);
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const playlistExportAction = playlist => {
    if (playlist.exportStatus === 'finished' && playlist.exportDownloadUrl) {
      return (
        <Fragment>
          <Button
            className="btn btn_red_rp mb-3 ml-1 mr-1"
            onClick={downloadPlaylistExport(playlist)}
          >
            {t('DOWNLOAD_MP4')}
          </Button>
          <Button className="btn btn_red_outline_rp mb-3 ml-1 mr-1" onClick={() => exportPlaylist(playlist.id, true)}>
            Rigenera MP4
          </Button>
        </Fragment>
      );
    }
    if (playlist.exportStatus === 'pending' || playlist.exportStatus === 'running') {
      return (
        <Button className="btn btn_red_outline_rp mb-3 ml-1 mr-1" disabled>
          Generazione in corso
        </Button>
      );
    }
    return (
      <Button className="btn btn_red_outline_rp mb-3 ml-1 mr-1" onClick={() => exportPlaylist(playlist.id)}>
        {playlist.exportStatus === 'error' ? 'Rigenera MP4' : 'Genera MP4 unico'}
      </Button>
    );
  };

  const confirmDownloadVideo = video => () => {
    dialog.show({
      title: t('CONFIRM_DOWNLOAD_VIDEO'),
      body: <Fragment>
        <Form.Group>
          {t('CONFIRM_DOWNLOAD_VIDEO_DESC', { name: video.name })}
        </Form.Group>
        <Form.Group>
          {video.urls.map(url => (
            <div style={{ paddingTop: 20 }}>
              <a href={url.url} download={video.name.split('.').join('') + '_' + url.cameraName} class="btn btn-secondary">{t('DOWNLOAD') + " " + (video.urls.length > 1 ? url.cameraName : "")}</a>
            </div>
          ))}
        </Form.Group>
      </Fragment>,
      actions: [
        Dialog.Action(
          t('CLOSE_BUTTON'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const metadataVideo = video => () => {
    dialog.show({
      title: t('VIDEO_METADATA'),
      body: <Fragment>
        <Form.Group>
          {t('VIDEO_METADATA_DESC')}
        </Form.Group>
        <Form.Group>
          <Form.Label><FaMapMarkerAlt size="1.5em" style={{ marginRight: 10 }} />{video.city}</Form.Label>
        </Form.Group>
        <Form.Group>
          <Form.Label><FaShieldAlt size="1.5em" style={{ marginRight: 10 }} />{video.partnerName}, {video.fieldName}</Form.Label>
        </Form.Group>
        <Form.Group>
          <Form.Label><AiOutlineCalendar size="1.5em" style={{ marginRight: 10 }} />{new Date(video.startDatetime).toLocaleDateString(i18n.language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</Form.Label>
        </Form.Group>
        <Form.Group>
          <Form.Label><AiOutlineClockCircle size="1.5em" style={{ marginRight: 10 }} />Dalle ore {new Date(video.startDatetime).toLocaleTimeString(i18n.language).slice(0, 5)} alle ore {new Date(video.endDatetime).toLocaleTimeString(i18n.language).slice(0, 5)}</Form.Label>
        </Form.Group>
      </Fragment>,
      actions: [
        Dialog.Action(
          t('CLOSE_BUTTON'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const uplodInfoDialog = () => {
    dialog.show({
      title: t('UPLOAD_INFO'),
      body: t('UPLOAD_VIDEO_SPECS'),
      actions: [
        Dialog.Action(
          t('CLOSE_BUTTON'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const getPartnerLogo = () => {
    if (profile && profile.storeImage && profile.storeImage.length > 0) {
      return `${Configuration.apiEndPoint}/images/${profile.uid}?load=${profile.storeImage[0]}`;
    }

    return noLogo;
  };

  const styleBackgroundImage = (partnerId, fieldId, fieldImage) => {
    if (partnerId && fieldImage) {
      return { backgroundImage: `url(${Configuration.apiEndPoint}/partners/fields/${fieldId}/images?load=${fieldImage})`, backgroundSize: 'cover' };
    }

    return null;
  };

  const styleBackgroundImageVideoPartner = (coverImage, defaultImage, videoId) => {
    if (coverImage && coverImage[0]) {
      return { backgroundImage: `url(${Configuration.apiEndPoint}/video_partners/${videoId}/images?load=${coverImage[0]}`, backgroundSize: 'cover' };
    }
    if (defaultImage && defaultImage[0]) {
      return { backgroundImage: `url(${Configuration.apiEndPoint}/images/${profile.uid}?load=${defaultImage[0]}`, backgroundSize: 'cover' };
    }

    return null;
  };

  const handleTagSelection = val => {
    setValue(val);
    searchTaggedVideo(val);
  };

  const storageLimit = {
    xs: 20,
    s: 30,
    m: 50,
    l: 100,
    xl: 200,
    xxl: 500,
    xxxl: 1000,
  };

  const selectableStorageType = profile.storageType === "xs" ? "s" : profile.storageType;

  const usageTypes = {
    replayer_video: 1,
    partner_video: 2,
    highlight: 3,
    playlist: 4,
  };


  const onUpload = id => () => {
    window.location.href = "/upload?video_id=" + id;
  };

  const isHighlight = v => v.highlight === true || v.highlight === 1 || v.highlight === 'true';
  const replayerVideos = permanentVideos.filter(v => !isHighlight(v));
  const videosWithoutFolderCount = replayerVideos.filter(v => !v.videoFolderId).length;
  const getVideoFolderCount = folderId => (
    replayerVideos.filter(v => String(v.videoFolderId) === String(folderId)).length
  );
  const visibleReplayerVideos = replayerVideos.filter(v => {
    if (activeVideoFolderId === 'all') {
      return true;
    }
    if (activeVideoFolderId === 'none') {
      return !v.videoFolderId;
    }
    return String(v.videoFolderId) === activeVideoFolderId;
  });
  const selectedVideoFolder = videoFolders.find(f => String(f.id) === activeVideoFolderId);

  const highlights = permanentVideos.filter(isHighlight);
  const highlightsWithoutFolderCount = highlights.filter(v => !v.highlightFolderId).length;
  const getHighlightFolderCount = folderId => (
    highlights.filter(v => String(v.highlightFolderId) === String(folderId)).length
  );
  const visibleHighlights = highlights.filter(v => {
    if (activeHighlightFolderId === 'all') {
      return true;
    }
    if (activeHighlightFolderId === 'none') {
      return !v.highlightFolderId;
    }
    return String(v.highlightFolderId) === activeHighlightFolderId;
  });
  const selectedHighlightFolder = highlightFolders.find(f => String(f.id) === activeHighlightFolderId);
  const selectedHighlights = visibleHighlights.filter(v => selectedHighlightIds.includes(v.videoId));
  const getAvailableFlatCameras = v => (
    Array.isArray(v.cameras)
      ? v.cameras.filter(camera => camera.camera_type === 'flat' && camera.cameraExistInSlotCamera)
      : []
  );
  const getSelectedHighlightCameraId = v => {
    const selectedCameraId = selectedHighlightCameraIds[v.videoId];
    if (selectedCameraId) {
      return Number(selectedCameraId);
    }
    const flatCameras = getAvailableFlatCameras(v);
    return flatCameras.length > 0 ? Number(flatCameras[0].value) : null;
  };
  const isFlatHighlight = v => (
    getAvailableFlatCameras(v).some(camera => Number(camera.value) === Number(getSelectedHighlightCameraId(v)))
  );
  const canCreateHighlightPlaylist = selectedHighlights.length >= 2 &&
    selectedHighlights.every(isFlatHighlight);
  const changeHighlightPlaylistCamera = videoId => event => {
    event.stopPropagation();
    setSelectedHighlightCameraIds(currentCameraIds => ({
      ...currentCameraIds,
      [videoId]: Number(event.target.value)
    }));
  };
  const toggleHighlightSelection = v => event => {
    event.stopPropagation();
    const flatCameras = getAvailableFlatCameras(v);
    if (flatCameras.length === 0) {
      return;
    }
    setSelectedHighlightCameraIds(currentCameraIds => ({
      ...currentCameraIds,
      [v.videoId]: currentCameraIds[v.videoId] || Number(flatCameras[0].value)
    }));
    setSelectedHighlightIds(currentIds => {
      if (currentIds.includes(v.videoId)) {
        const nextIds = currentIds.filter(id => id !== v.videoId);
        setSelectedHighlightCameraIds(currentCameraIds => {
          const nextCameraIds = { ...currentCameraIds };
          delete nextCameraIds[v.videoId];
          return nextCameraIds;
        });
        return nextIds;
      }
      return [...currentIds, v.videoId];
    });
  };
  const clearHighlightPlaylistSelection = () => {
    setSelectedHighlightIds([]);
    setSelectedHighlightCameraIds({});
  };
  const openHighlightPlaylistModal = event => {
    event.preventDefault();
    if (canCreateHighlightPlaylist) {
      setHighlightPlaylistModalVisible(true);
    }
  };
  const shareSelectedHighlightFolder = event => {
    event.preventDefault();
    if (!selectedHighlightFolder) {
      return;
    }
    showVideosSharing({
      name: selectedHighlightFolder.name,
      sharing: selectedHighlightFolder.sharing,
      sharingId: selectedHighlightFolder.sharingId,
      folderId: selectedHighlightFolder.id
    })();
  };

  const addHighlightFolder = event => {
    event.preventDefault();
    const folderName = newHighlightFolderName.trim();
    if (!folderName) {
      return;
    }
    createPartnerHighlightFolder(folderName);
    setPendingHighlightFolderName(folderName);
    setNewHighlightFolderName('');
  };

  const addVideoFolder = event => {
    event.preventDefault();
    const folderName = newVideoFolderName.trim();
    if (!folderName) {
      return;
    }
    createPartnerVideoFolder(folderName);
    setPendingVideoFolderName(folderName);
    setNewVideoFolderName('');
  };

  const deleteSelectedHighlightFolder = event => {
    event.preventDefault();
    if (!selectedHighlightFolder) {
      return;
    }
    dialog.show({
      title: t('MYVIDEO_DELETE_FOLDER'),
      body: (
        <Fragment>
          <p>{t('MYVIDEO_DELETE_FOLDER_CONFIRM', {name: selectedHighlightFolder.name})}</p>
          <p>{t('MYVIDEO_DELETE_HIGHLIGHT_FOLDER_HELP')}</p>
        </Fragment>
      ),
      actions: [
        Dialog.Action(
          t('MYVIDEO_DELETE_FOLDER'),
          () => {
            deletePartnerHighlightFolder(selectedHighlightFolder.id);
            setActiveHighlightFolderId('all');
          },
          'btn btn-secondary'
        ),
        Dialog.Action(t('CANCEL'), null, 'btn btn_red_outline_rp')
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const deleteSelectedVideoFolder = event => {
    event.preventDefault();
    if (!selectedVideoFolder) {
      return;
    }
    dialog.show({
      title: t('MYVIDEO_DELETE_FOLDER'),
      body: (
        <Fragment>
          <p>{t('MYVIDEO_DELETE_FOLDER_CONFIRM', {name: selectedVideoFolder.name})}</p>
          <p>{t('MYVIDEO_DELETE_VIDEO_FOLDER_HELP')}</p>
        </Fragment>
      ),
      actions: [
        Dialog.Action(
          t('MYVIDEO_DELETE_FOLDER'),
          () => {
            deletePartnerVideoFolder(selectedVideoFolder.id);
            setActiveVideoFolderId('all');
          },
          'btn btn-secondary'
        ),
        Dialog.Action(t('CANCEL'), null, 'btn btn_red_outline_rp')
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const renderPlayer = (players) => {
    return (
      <div>
        <ul class="list-group list-group-light mb-4">
          {
            players.map((p, index) =>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  {p.image && p.image[0] ?
                    <img
                      className="img-fluid"
                      src={`${Configuration.apiEndPoint}/images/${p.uid}?load=${p.image[0]}`}
                      alt={t('PROFILE_IMAGE')}
                      style={{ width: 45, height: 45, paddingLeft: 0 }}
                      class="rounded-circle"
                    />
                    :
                    <img
                      className="img-fluid"
                      src={defaultAvatar}
                      alt={t('PROFILE_IMAGE')}
                      style={{ width: 45, height: 45, paddingLeft: 0 }}
                      class="rounded-circle"
                    />
                  }
                  <div class="ms-3">
                    <p class="fw-bold mb-1" style={{ marginLeft: 10 }}>{p.name + " " + p.surname}</p>
                    <p class="fw-bold mb-1" style={{ marginLeft: 10 }}>{p.nickname}</p>
                  </div>
                </div>
                <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={() => players.splice(index, 1)}><img src={binIcon} alt={t('ICON_DELETE')} /></button></li>
              </li>
            )
          }
        </ul>
      </div>
    )
  }

  const renderPlayerSearch = player => {
    return (
      <div key={player.uid}>
        <ul class="list-group list-group-light mb-4">
          <li class="list-group-item d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              {player && player.image && player.image[0] ?
                <img
                  className="img-fluid"
                  src={`${Configuration.apiEndPoint}/images/${player.uid}?load=${player.image[0]}`}
                  alt={t('PROFILE_IMAGE')}
                  style={{ width: 45, height: 45, paddingLeft: 0 }}
                  class="rounded-circle"
                />
                :
                <img
                  className="img-fluid"
                  src={defaultAvatar}
                  alt={t('PROFILE_IMAGE')}
                  style={{ width: 45, height: 45, paddingLeft: 0 }}
                  class="rounded-circle"
                />
              }
              <div class="ms-3">
                <p class="fw-bold mb-1" style={{ marginLeft: 10 }}>{player.name + " " + player.surname}</p>
                <p class="fw-bold mb-1" style={{ marginLeft: 10 }}>{player.nickname + (player.groupType ? " - " + player.groupType : "")}</p>
              </div>
            </div>
            <Form.Check required name="selectedPlayer" type="radio" onChange={() => setSelectedPlayer(player)} />
          </li>
        </ul>
      </div>
    )
  }

  const showPartnerVideoChangeModal = v => {
    setSelectedPlayers(v.selectedPlayers);
    showPartnerVideoEditModal(v);
  }

  const playPartnerVideo = v => () => {
    if (v.videoName) {
      sendUsageData(usageTypes['partner_video'], v.partnerId, null, v.title, v.videoName);
      window.open(`${Configuration.krpanoPlayerUrl}?videoPartnerId=${v.videoId}&token=${v.token}`, '_blank');
    }
  }

  return (
    <Fragment>
      <CommonMetaTag />
      <Fade in appear className="bg_white" style={{ transition: 'opacity 0.30s linear' }}>
        <Container fluid className="presentation-container">
          <div className="page-header header-filter clear-filter dashboard_hero_rp" data-parallax="true">
            <div className="dashboard_hero_overlay_rp" />
          </div>
          <div className="main main_raised_rp" style={{ minHeight: 800 }}>
            <div className="section">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 ml-auto mr-auto">
                    <h4 className="section_title_neg_rp">{t('MY_VIDEO')}</h4>
                    <br />
                    <h4 className="section_title_neg_rp">{(Math.floor(profile.videoQuota) / (1000000000)).toFixed(2)}GB/{storageLimit[profile.storageType]}GB</h4>
                  </div>
                  <div className="col-md-12 ml-auto mr-auto" style={{ textAlign: 'right', marginTop: -42 }}>
                    <button type="button" className="btn myvideo-action myvideo-action--utility mb-3 ml-1 mr-1" onClick={showStorageModal}><FaDatabase aria-hidden="true" />{t('MANAGE_SPACE')}</button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 ml-auto mr-auto">
                    <Tabs activeKey={myVideoActiveTab} className="myvideo-tabs myvideo-section-tabs" onSelect={t => setActiveTab(t)}>
                      <Tab eventKey="highlight" title={<span className="section-tab-label"><FaMagic aria-hidden="true" />{t('HIGHLIGHT')}</span>} tabClassName="myvideo-tab">
                        <div className="myvideo-highlight-organizer" style={{ marginTop: 35 }}>
                          <div className="myvideo-highlight-organizer-header">
                            <div>
                              <h5>{t('ORGANIZE_HIGHLIGHTS')}</h5>
                              <p>{t('ORGANIZE_HIGHLIGHTS_DESCRIPTION')}</p>
                            </div>
                            <div className="myvideo-highlight-header-actions">
                              <Button className="myvideo-highlight-guide-btn" onClick={() => setHighlightGuideModalVisible(true)}>{t('HIGHLIGHT_GUIDE')}</Button>
                              <div className="myvideo-highlight-total">{highlights.length} highlight</div>
                            </div>
                          </div>
                          <div className="row align-items-stretch myvideo-highlight-controls">
                            <div className="col-md-5 mb-3">
                              <div className="myvideo-highlight-control-card myvideo-folder-control-card">
                                <Form.Label className="myvideo-folder-control-label"><FaFilter aria-hidden="true" /><span>{t('SHOW')}</span></Form.Label>
                                <Form.Control className="myvideo-folder-select" as="select" value={activeHighlightFolderId} onChange={event => setActiveHighlightFolderId(event.target.value)}>
                                  <option value="all">{t('MYVIDEO_ALL_HIGHLIGHTS', {count: highlights.length})}</option>
                                  <option value="none">{t('MYVIDEO_HIGHLIGHTS_WITHOUT_FOLDER', {count: highlightsWithoutFolderCount})}</option>
                                  {highlightFolders.map(folder => (
                                    <option key={folder.id} value={folder.id}>{t('MYVIDEO_FOLDER_OPTION', {name: folder.name, count: getHighlightFolderCount(folder.id)})}</option>
                                  ))}
                                </Form.Control>
                                <small className="myvideo-folder-control-hint">{t('MYVIDEO_HIGHLIGHTS_IN_SELECTION', {count: visibleHighlights.length})}</small>
                              </div>
                            </div>
                            <div className="col-md-5 mb-3">
                              <div className="myvideo-highlight-control-card myvideo-folder-control-card">
                                <Form onSubmit={addHighlightFolder}>
                                  <Form.Label className="myvideo-folder-control-label"><FaFolderPlus aria-hidden="true" /><span>{t('NEW_FOLDER')}</span></Form.Label>
                                  <div className="input-group myvideo-folder-create-control">
                                    <Form.Control maxLength={120} value={newHighlightFolderName} placeholder={t('FOLDER_NAME')} onChange={event => setNewHighlightFolderName(event.target.value)} />
                                    <div className="input-group-append">
                                      <Button type="submit" className="btn myvideo-action myvideo-folder-create-btn" disabled={!newHighlightFolderName.trim()}><FaPlus aria-hidden="true" />{t('CREATE')}</Button>
                                    </div>
                                  </div>
                                  <small className="myvideo-folder-control-hint">{t('HIGHLIGHT_FOLDER_HINT')}</small>
                                </Form>
                              </div>
                            </div>
                            <div className="col-md-2 mb-3 text-md-right">
                              {selectedHighlightFolder ? (
                                <div className="myvideo-highlight-folder-actions">
                                  <Button className="btn myvideo-action myvideo-action--share mb-2" onClick={shareSelectedHighlightFolder}><FaShareAlt aria-hidden="true" />{t('MYVIDEO_SHARE_FOLDER')}</Button>
                                  <Button className="btn myvideo-action myvideo-action--danger" onClick={deleteSelectedHighlightFolder}><FaTrashAlt aria-hidden="true" />{t('MYVIDEO_DELETE_FOLDER')}</Button>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        {selectedHighlightIds.length > 0 ? (
                          <div className="myvideo-highlight-playlist-bar">
                            <div>
                              <strong>{t('MYVIDEO_HIGHLIGHTS_SELECTED', {count: selectedHighlightIds.length})}</strong>
                              <span>
                                {canCreateHighlightPlaylist
                                  ? t('MYVIDEO_PLAYLIST_READY')
                                  : t('MYVIDEO_PLAYLIST_MINIMUM_HELP')}
                              </span>
                            </div>
                            <div className="myvideo-highlight-playlist-actions">
                              <Button className="btn myvideo-action myvideo-action--utility" onClick={clearHighlightPlaylistSelection}><FaTimes aria-hidden="true" />{t('MYVIDEO_CANCEL_SELECTION')}</Button>
                              <Button className="btn myvideo-action myvideo-action--playlist" disabled={!canCreateHighlightPlaylist} onClick={openHighlightPlaylistModal}><FaFolderPlus aria-hidden="true" />{t('MYVIDEO_CREATE_PLAYLIST')}</Button>
                            </div>
                          </div>
                        ) : null}
                        <div className="row" style={{ marginTop: 50 }}>
                          {visibleHighlights.length === 0 ? (
                            <div className="col-12">
                              <div className="myvideo-highlight-empty">
                                {selectedHighlightFolder
                                  ? t('MYVIDEO_EMPTY_HIGHLIGHT_FOLDER')
                                  : t('MYVIDEO_NO_HIGHLIGHTS_SELECTION')}
                              </div>
                            </div>
                          ) : null}
                          
                          {
                           
                            visibleHighlights.map(v =>
                            (
                              <div key={v.videoId} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                <div className="card video_card_bg_rp skywork-video-content-card skywork-video-content-card--highlight">
                                  <div className="video_card_image" style={styleBackgroundImage(v.partnerId, v.fieldId, v.fieldImage)}>
                                    <div className="videoWrapper" onClick={() => { sendUsageData(usageTypes['highlight'], v.partnerId, v.slotId); window.open(`${Configuration.krpanoPlayerUrl}?videoId=${v.videoId}&token=${v.token}`, '_blank'); }}>
                                      <Fragment>
                                        <div className="preload h-100 justify-content-center align-items-center">
                                          <img className="play_arrow" src={playArrowWhite} alt="" />
                                        </div>
                                        <div className="preload h-100 justify-content-start align-items-start">
                                          <img className="logo-replayer" src={replayerlogoBianco} alt="" />
                                        </div>
                                        <div className="preload h-100 justify-content-end align-items-start">
                                          <img className="logo-partner" src={getPartnerLogo()} alt="" />
                                        </div>
                                        <div className="preload h-100 justify-content-center align-items-end">
                                          <div className="video-description justify-content-center align-items-center">{v.name.substring(0, 60)}</div>
                                        </div>
                                      </Fragment>
                                    </div>
                                  </div>
                                  <Formik
                                    enableReinitialize
                                    initialValues={{ videoId: v.videoId, name: v.name, description: v.description, renaming: false }}
                                    onSubmit={values => modifyPartnerPermanentVideo(values.videoId, { name: values.name, description: values.description })}
                                  >
                                    {({
                                      handleSubmit,
                                      handleChange,
                                      values,
                                      setFieldValue
                                    }) => {
                                      const rename = formData => {
                                        handleSubmit(formData);
                                        setFieldValue('renaming', false);
                                      };

                                      const setRenameAndScroll = () => {
                                        setScrollPosition(getScrollPage());
                                        setFieldValue('renaming', true);
                                      };

                                      if (values.renaming) {
                                        return (
                                          <div className="card-body d-flex flex-column">
                                            <Form onSubmit={rename}>
                                              <Form.Group>
                                                <Form.Label>{t('TITLE')}*</Form.Label>
                                                <Form.Control required name="name" type="text" placeholder={t('TITLE')} maxLength={255} value={values.name || ''} onChange={handleChange} />
                                              </Form.Group>
                                              <Form.Group>
                                                <Form.Label>{t('DESCRIPTION')}</Form.Label>
                                                <Form.Control name="description" as="textarea" maxLength={255} placeholder={t('DESCRIPTION')} value={values.description || ''} onChange={handleChange} />
                                              </Form.Group>
                                              <div className="d-flex flex-row-reverse">
                                                <button type="button" className="btn myvideo-action myvideo-action--utility ml-1" onClick={() => setFieldValue('renaming', false)}><FaTimes aria-hidden="true" />{t('CANCEL')}</button>
                                                <Button className="btn myvideo-action myvideo-action--primary ml-1 mr-1" type="submit">{t('SAVE')}</Button>
                                              </div>
                                            </Form>
                                          </div>
                                        );
                                      }

                                      return (
                                        <Fragment>
                                          <div className="card-body d-flex flex-column">
                                            <div className="skywork-video-card-title-box"><h5 className="card-title">{v.name}</h5></div>
                                            <div className="video_card_star_btn_active" onClick={metadataVideo(v)} />
                                            <div className="skywork-video-card-description-box">{v.description || t('NO_DESCRIPTION')}</div>
                                          </div>
                                          <div className="px-3 pb-3 myvideo-card-folder-control">
                                            <Form.Label><FaFolder aria-hidden="true" /><span>{t('MYVIDEO_ARCHIVE_IN')}</span></Form.Label>
                                            <Form.Control className="myvideo-card-folder-select" as="select" value={v.highlightFolderId || ''} onChange={event => movePartnerHighlightToFolder(v.videoId, event.target.value ? Number(event.target.value) : null)}>
                                              <option value="">{t('MYVIDEO_WITHOUT_FOLDER')}</option>
                                              {highlightFolders.map(folder => (
                                                <option key={folder.id} value={folder.id}>{folder.name}</option>
                                              ))}
                                            </Form.Control>
                                          </div>
                                          <div className="px-3 pb-3">
                                            <div className="myvideo-highlight-playlist-card">
                                              <div className="myvideo-highlight-playlist-card-title">{t('PLAYLIST')}</div>
                                              {getAvailableFlatCameras(v).length === 0 ? (
                                                <div className="myvideo-highlight-playlist-card-muted">{t('MYVIDEO_NO_FLAT_CAMERAS')}</div>
                                              ) : (
                                                <Fragment>
                                                  {getAvailableFlatCameras(v).length > 1 ? (
                                                    <Form.Control
                                                      as="select"
                                                      className="mb-2"
                                                      value={getSelectedHighlightCameraId(v) || ''}
                                                      onChange={changeHighlightPlaylistCamera(v.videoId)}
                                                    >
                                                      {getAvailableFlatCameras(v).map(camera => (
                                                        <option key={camera.value} value={camera.value}>{camera.label || camera.name || `Camera ${camera.value}`}</option>
                                                      ))}
                                                    </Form.Control>
                                                  ) : null}
                                                  <Button
                                                    className={`btn myvideo-action myvideo-action--playlist w-100 ${selectedHighlightIds.includes(v.videoId) ? 'active' : ''}`}
                                                    onClick={toggleHighlightSelection(v)}
                                                  >
                                                    {selectedHighlightIds.includes(v.videoId) ? t('SELECTED_FOR_PLAYLIST') : t('ADD_TO_PLAYLIST')}
                                                  </Button>
                                                </Fragment>
                                              )}
                                            </div>
                                          </div>
                                          <div className="card_border_bottom_white text-center mt-auto mb-3">
                                            <button type="button" className="btn myvideo-action myvideo-action--share mb-3 ml-1 mr-1" onClick={showVideosSharing(v)}><FaShareAlt aria-hidden="true" />{t('SHARE')}</button>
                                            <button type="button" className="btn myvideo-action myvideo-action--download mb-3 ml-1 mr-1" onClick={confirmDownloadVideo(v)}><FaDownload aria-hidden="true" />{t('DOWNLOAD')}</button>
                                          </div>
                                          <ul className="card_video_archive_list_icons mb-3">
                                            <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={setRenameAndScroll}><img src={editIcon} alt={t('ICON_CHANGE')} /></button></li>
                                            <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={confirmDeleteVideo(v.videoId)}><img src={binIcon} alt={t('ICON_DELETE')} /></button></li>
                                            {
                                              v.sharing === sharingType.none ?
                                                <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={privateIcon} alt={t('ICON_USER_PRIVATE')} /><br />{t('PRIVATE')}</li> :
                                                null
                                            }
                                            {
                                              v.sharing === sharingType.public ?
                                                <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={publicIcon} alt={t('ICON_USER_PUBLIC')} /><br />{t('PUBLIC')}</li> :
                                                null
                                            }
                                            {
                                              v.sharing === sharingType.replayer ?
                                                <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={replayerIcon} alt={t('ICON_USER_REPLAYER')} /><br />{t('REPLAYER_USERS')}</li> :
                                                null
                                            }
                                            <p style={{ textAlign: 'right', paddingRight: 10, paddingTop: 10, whiteSpace: 'nowrap' }}>{(Math.floor(v.filesize) / (1000000000)).toFixed(2)}GB</p>
                                          </ul>
                                        </Fragment>
                                      );
                                    }}
                                  </Formik>
                                </div>
                              </div>
                            ))
                          }
                          <div className="col-md-12 col-lg-4 mb-sm-4 card-group">
                            <div className="empty_slot card video_card_bg_rp">
                              <div className="card_image_rp">
                                <div className="videoWrapper" />
                              </div>
                              <div className="card-body d-flex flex-column">
                                <h5 className="card-title">{t('ADD_NEW_HIGHLIGHT_HERE')}</h5>
                                <p>
                                  {t('HIGH_DEFINITION_HIGHLIGHT_SHOOTING_FIELDS')}
                                </p>
                                <div className="text-center mt-auto">
                                  <button type="button" className="btn myvideo-action myvideo-action--utility mb-2" onClick={() => setActiveTab('video')}><FaFilm aria-hidden="true" />{t('MY_VIDEO')}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      <Tab eventKey="video" title={<span className="section-tab-label"><FaFilm aria-hidden="true" />{t('REPLAYER_VIDEOS')}</span>} tabClassName="myvideo-tab">
                        <div className="myvideo-highlight-organizer" style={{ marginTop: 35 }}>
                          <div className="myvideo-highlight-organizer-header">
                            <div>
                              <h5>{t('ORGANIZE_VIDEOS')}</h5>
                              <p>{t('ORGANIZE_VIDEOS_DESCRIPTION')}</p>
                            </div>
                            <div className="myvideo-highlight-header-actions">
                              <Button className="myvideo-highlight-guide-btn" onClick={() => setVideoGuideModalVisible(true)}>{t('VIDEO_GUIDE')}</Button>
                              <div className="myvideo-highlight-total">{replayerVideos.length} video</div>
                            </div>
                          </div>
                          <div className="row align-items-stretch myvideo-highlight-controls">
                            <div className="col-md-5 mb-3">
                              <div className="myvideo-highlight-control-card myvideo-folder-control-card">
                                <Form.Label className="myvideo-folder-control-label"><FaFilter aria-hidden="true" /><span>{t('SHOW')}</span></Form.Label>
                                <Form.Control className="myvideo-folder-select" as="select" value={activeVideoFolderId} onChange={event => setActiveVideoFolderId(event.target.value)}>
                                  <option value="all">{t('MYVIDEO_ALL_VIDEOS', {count: replayerVideos.length})}</option>
                                  <option value="none">{t('MYVIDEO_VIDEOS_WITHOUT_FOLDER', {count: videosWithoutFolderCount})}</option>
                                  {videoFolders.map(folder => (
                                    <option key={folder.id} value={folder.id}>{t('MYVIDEO_FOLDER_OPTION', {name: folder.name, count: getVideoFolderCount(folder.id)})}</option>
                                  ))}
                                </Form.Control>
                                <small className="myvideo-folder-control-hint">{t('MYVIDEO_VIDEOS_IN_SELECTION', {count: visibleReplayerVideos.length})}</small>
                              </div>
                            </div>
                            <div className="col-md-5 mb-3">
                              <div className="myvideo-highlight-control-card myvideo-folder-control-card">
                                <Form onSubmit={addVideoFolder}>
                                  <Form.Label className="myvideo-folder-control-label"><FaFolderPlus aria-hidden="true" /><span>{t('NEW_FOLDER')}</span></Form.Label>
                                  <div className="input-group myvideo-folder-create-control">
                                    <Form.Control maxLength={120} value={newVideoFolderName} placeholder={t('FOLDER_NAME')} onChange={event => setNewVideoFolderName(event.target.value)} />
                                    <div className="input-group-append">
                                      <Button type="submit" className="btn myvideo-action myvideo-folder-create-btn" disabled={!newVideoFolderName.trim()}><FaPlus aria-hidden="true" />{t('CREATE')}</Button>
                                    </div>
                                  </div>
                                  <small className="myvideo-folder-control-hint">{t('VIDEO_FOLDER_HINT')}</small>
                                </Form>
                              </div>
                            </div>
                            <div className="col-md-2 mb-3 text-md-right">
                              {selectedVideoFolder ? (
                                <div className="myvideo-highlight-folder-actions">
                                  <Button className="btn myvideo-action myvideo-action--danger" onClick={deleteSelectedVideoFolder}><FaTrashAlt aria-hidden="true" />{t('MYVIDEO_DELETE_FOLDER')}</Button>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginTop: 50 }}>
                          {visibleReplayerVideos.length === 0 ? (
                            <div className="col-12">
                              <div className="myvideo-highlight-empty">
                                {selectedVideoFolder
                                  ? t('MYVIDEO_EMPTY_VIDEO_FOLDER')
                                  : t('MYVIDEO_NO_VIDEOS_SELECTION')}
                              </div>
                            </div>
                          ) : null}
                          {
                            visibleReplayerVideos.map(v =>
                            (
                              <div key={v.videoId} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                <div className="card video_card_bg_rp skywork-video-content-card skywork-video-content-card--replayer">
                                  <div className="video_card_image" style={styleBackgroundImage(v.partnerId, v.fieldId, v.fieldImage)}>
                                    <div className="videoWrapper" onClick={() => { sendUsageData(usageTypes['replayer_video'], v.partnerId, v.slotId); window.open(`${Configuration.krpanoPlayerUrl}?slotId=${v.slotId}&token=${v.token}`, '_blank'); }}>
                                      <Fragment>
                                        <div className="preload h-100 justify-content-center align-items-center">
                                          <img className="play_arrow" src={playArrowWhite} alt="" />
                                        </div>
                                        <div className="preload h-100 justify-content-start align-items-start">
                                          <img className="logo-replayer" src={replayerlogoBianco} alt="" />
                                        </div>
                                        <div className="preload h-100 justify-content-end align-items-start">
                                          <img className="logo-partner" src={getPartnerLogo()} alt="" />
                                        </div>
                                        <div className="preload h-100 justify-content-center align-items-end">
                                          <div className="video-description justify-content-center align-items-center">{v.name.substring(0, 60)}</div>
                                        </div>
                                      </Fragment>
                                    </div>
                                  </div>
                                  <Formik
                                    enableReinitialize
                                    initialValues={{ videoId: v.videoId, name: v.name, description: v.description, renaming: false }}
                                    onSubmit={values => modifyPartnerPermanentVideo(values.videoId, { name: values.name, description: values.description })}
                                  >
                                    {({
                                      handleSubmit,
                                      handleChange,
                                      values,
                                      setFieldValue
                                    }) => {
                                      const rename = formData => {
                                        handleSubmit(formData);
                                        setFieldValue('renaming', false);
                                      };

                                      const setRenameAndScroll = () => {
                                        setScrollPosition(getScrollPage());
                                        setFieldValue('renaming', true);
                                      };

                                      if (values.renaming) {
                                        return (
                                          <div className="card-body d-flex flex-column">
                                            <Form onSubmit={rename}>
                                              <Form.Group>
                                                <Form.Label>{t('TITLE')}*</Form.Label>
                                                <Form.Control required name="name" type="text" placeholder={t('TITLE')} maxLength={255} value={values.name || ''} onChange={handleChange} />
                                              </Form.Group>
                                              <Form.Group>
                                                <Form.Label>{t('DESCRIPTION')}</Form.Label>
                                                <Form.Control name="description" as="textarea" maxLength={255} placeholder={t('DESCRIPTION')} value={values.description || ''} onChange={handleChange} />
                                              </Form.Group>
                                              <div className="d-flex flex-row-reverse">
                                                <button type="button" className="btn myvideo-action myvideo-action--utility ml-1" onClick={() => setFieldValue('renaming', false)}><FaTimes aria-hidden="true" />{t('CANCEL')}</button>
                                                <Button className="btn myvideo-action myvideo-action--primary ml-1 mr-1" type="submit">{t('SAVE')}</Button>
                                              </div>
                                            </Form>
                                          </div>
                                        );
                                      }

                                      return (
                                        <Fragment>
                                          <div className="card-body d-flex flex-column">
                                            <div className="skywork-video-card-title-box"><h5 className="card-title">{v.name}</h5></div>
                                            <div className="video_card_star_btn_active" onClick={metadataVideo(v)} />
                                            <div className="skywork-video-card-description-box">{v.description || t('NO_DESCRIPTION')}</div>
                                          </div>
                                          <div className="px-3 pb-3 myvideo-card-folder-control">
                                            <Form.Label><FaFolder aria-hidden="true" /><span>{t('MYVIDEO_ARCHIVE_IN')}</span></Form.Label>
                                            <Form.Control className="myvideo-card-folder-select" as="select" value={v.videoFolderId || ''} onChange={event => movePartnerVideoToFolder(v.videoId, event.target.value ? Number(event.target.value) : null)}>
                                              <option value="">{t('MYVIDEO_WITHOUT_FOLDER')}</option>
                                              {videoFolders.map(folder => (
                                                <option key={folder.id} value={folder.id}>{folder.name}</option>
                                              ))}
                                            </Form.Control>
                                          </div>
                                          <div className="card_border_bottom_white text-center mt-auto mb-3">
                                            <button type="button" className="btn myvideo-action myvideo-action--share mb-3 ml-1 mr-1" onClick={showVideosSharing(v)}><FaShareAlt aria-hidden="true" />{t('SHARE')}</button>
                                            {Array.isArray(v.cameras) && v.cameras.some(c => c.camera_type === 'flat') && (
                                              <button
                                                type="button"
                                                className="btn myvideo-action myvideo-action--tag mb-3 ml-1 mr-1"
                                                onClick={showVideoTagging(v)}><FaTag aria-hidden="true" />{t('VIDEO_TAG_CREATE')}
                                              </button>
                                            )}
                                            <button type="button" className="btn myvideo-action myvideo-action--highlight mb-3 ml-1 mr-1" onClick={selectVideoForHighlight(v)}><FaMagic aria-hidden="true" />{t('HIGHLIGHT')}</button>
                                            {isPickleballVideo(v) ? <button type="button" className="btn myvideo-action myvideo-action--analysis mb-3 ml-1 mr-1" onClick={selectVideoForAnalysis(v)}><FaChartBar aria-hidden="true" />{t('ANALYSIS')}</button> : null}
                                          </div>
                                          {/* <div className="card_border_bottom_white text-center mt-auto mb-3">
                                              <button type="button" className="btn btn_blue_rp mb-3 ml-1 mr-1" onClick={showVideoTagging(v)}>{t('VIDEO_TAG_CREATE')}</button>
                                              <a href="#" className="btn btn_red_rp mb-3 ml-1 mr-1" onClick={selectVideoForHighlight(v)}>{t('HIGHLIGHT')}</a>
                                            </div> */}
                                          <ul className="card_video_archive_list_icons mb-3">
                                            <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={confirmDownloadVideo(v)}><img src={downloadIcon} alt={t('ICON_DOWNLOAD')} /></button></li>
                                            <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={setRenameAndScroll}><img src={editIcon} alt={t('ICON_CHANGE')} /></button></li>
                                            <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={confirmDeleteVideo(v.videoId)}><img src={binIcon} alt={t('ICON_DELETE')} /></button></li>
                                            {
                                              v.sharing === sharingType.none ?
                                                <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={privateIcon} alt={t('ICON_USER_PRIVATE')} /><br />{t('PRIVATE')}</li> :
                                                null
                                            }
                                            {
                                              v.sharing === sharingType.public ?
                                                <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={publicIcon} alt={t('ICON_USER_PUBLIC')} /><br />{t('PUBLIC')}</li> :
                                                null
                                            }
                                            {
                                              v.sharing === sharingType.replayer ?
                                                <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={replayerIcon} alt={t('ICON_USER_REPLAYER')} /><br />{t('REPLAYER_USERS')}</li> :
                                                null
                                            }
                                            <p style={{ textAlign: 'right', paddingRight: 10, paddingTop: 10 }}>{(Math.floor(v.filesize) / (1000000000)).toFixed(2)}GB</p>
                                            <li className="skywork-video-card-footer-folder"><FaFolder aria-hidden="true" /><span>Cartella: {v.videoFolderName || 'Senza cartella'}</span></li>
                                          </ul>
                                        </Fragment>
                                      );
                                    }}
                                  </Formik>
                                </div>
                              </div>
                            ))
                          }
                          <div className="col-md-12 col-lg-4 mb-sm-4 card-group">
                            <div className="empty_slot card video_card_bg_rp">
                              <div className="card_image_rp">
                                <div className="videoWrapper" />
                              </div>
                              <div className="card-body d-flex flex-column">
                                <h5 className="card-title">{t('ADD_NEW_VIDEO_HERE')}</h5>
                                <p>
                                  {t('HIGH_DEFINITION_VIDEO_SHOOTING_FIELDS')}
                                </p>
                                <div className="text-center mt-auto">
                                  <button type="button" className="btn myvideo-action myvideo-action--primary mb-2" onClick={goto('partner-replayer-tv-home')} style={{ marginRight: 10 }}><FaFilm aria-hidden="true" />{t('REPLAYER_TV')}</button>
                                  <button type="button" className="btn myvideo-action myvideo-action--utility mb-2" onClick={goto('partner-video-store', showVideosStorePartner)}><FaFilm aria-hidden="true" />{t('VIDEO_STORE')}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      <Tab eventKey="partner_videos" title={<span className="section-tab-label"><FaHandshake aria-hidden="true" />{t('PARTNER_VIDEOS')}</span>} tabClassName="myvideo-tab">
                        <div className="container pt-5">
                          <div className="row mb-4">
                            <div className="col-12">
                              <div className="d-flex" style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                                <div className="ml-auto d-xs-block"><Button variant="primary" onClick={showPartnerVideoCreationModal}>{t('ADD_VIDEO')}</Button></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginTop: 50 }}>
                          {
                            partnerVideos.map(v =>
                            (
                              <div key={v.videoId} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                <div className="card video_partner_card_bg_rp skywork-video-content-card skywork-video-content-card--partner">
                                  <div className="video_card_image" style={styleBackgroundImageVideoPartner(v.coverImage, profile.videoImage, v.videoId)}>
                                    <div className="videoWrapper" onClick={playPartnerVideo(v)}>
                                      <Fragment>
                                        {v.videoName ?
                                          <div className="preload h-100 justify-content-center align-items-center">
                                            <img className="play_arrow" src={playArrowWhite} alt="" />
                                          </div>
                                          : null}
                                        <div className="preload h-100 justify-content-start align-items-start">
                                          <img className="logo-replayer" src={replayerlogoBianco} alt="" />
                                        </div>
                                        <div className="preload h-100 justify-content-end align-items-start">
                                          <img className="logo-partner" src={getPartnerLogo()} alt="" />
                                        </div>
                                        <div className="preload h-100 justify-content-center align-items-end">
                                          <div className="video-description justify-content-center align-items-center">{v.title}</div>
                                        </div>
                                      </Fragment>
                                    </div>
                                  </div>
                                  <Fragment>
                                    <div className="card-body d-flex flex-column">
                                      <div className="skywork-video-card-title-box"><h5 className="card-title">{v.title}</h5></div>
                                      <div className="skywork-video-card-description-box">{v.description || t('NO_DESCRIPTION')}</div>
                                    </div>
                                    <div className="card_border_bottom_red mt-auto mb-3" style={{ paddingLeft: 20, paddingRight: 20 }}>
                                      {v.videoName ?
                                        <ul className="list-unstyled">
                                          <li>{t('FILE_NAME')}{": " + v.uploadFilename}</li>
                                          <li>{t('UPLOAD_DATE')}{": " + v.uploadDate.replace(/T.*/, '').split('-').reverse().join('/')}</li>
                                          <li>{t('VIDEO_COST')}{": " + v.videoCost.toFixed(2).replace('.', ',') + " €"}</li>
                                          <li>{t('VIDEO_PRICE')}{": " + v.videoPrice.toFixed(2).replace('.', ',') + " €"}</li>
                                          <li>{t('VIDEO_DURATION')}{": " + v.duration_minutes + ":" + String(Math.floor(v.duration_seconds)).padStart(2, '0')}</li>
                                          <li style={{ color: v.public !== null ? '#dd004a' : '#C9CED4' }}>{v.public ? t('VIDEO_FOR_SALE_PUBLIC') : v.public === null ? t('VIDEO_NOT_FOR_SALE') : t('VIDEO_FOR_SALE_PRIVATE')}</li>
                                          {profile.rtvChannels.filter(c => c.type === 1).length ?
                                            <li style={{ color: v.rtv ? '#dd004a' : '#C9CED4' }}>{v.rtv ? t('VIDEO_ON_RTV') : t('VIDEO_NOT_ON_RTV')}</li>
                                            : null}
                                        </ul>
                                        : null}
                                    </div>
                                    <ul className="card_video_archive_list_icons mb-3" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                      <div>
                                        <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={() => showPartnerVideoChangeModal(v)}><img src={editIcon} alt={t('ICON_CHANGE')} /></button></li>
                                        <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={confirmDeletePartnerVideo(v.videoId)}><img src={binIcon} alt={t('ICON_DELETE')} /></button></li>
                                      </div>
                                      {v.videoName ?
                                        <p style={{ textAlign: 'right', paddingRight: 10, paddingTop: 10 }}>{(Math.floor(v.filesize) / (1000000000)).toFixed(2)}GB</p>
                                        :
                                        <Button variant="warning" onClick={onUpload(v.videoId)}>
                                          {t('VIDEO_UPLOAD')}
                                        </Button>
                                      }
                                    </ul>
                                  </Fragment>
                                </div>
                              </div>
                            ))
                          }
                          <div className="col-md-12 col-lg-4 mb-sm-4 card-group">
                            <div className="empty_slot card video_card_bg_rp">
                              <div className="card_image_rp">
                                <div className="videoWrapper" />
                              </div>
                              <div className="card-body d-flex flex-column">
                                <h5 className="card-title">{t('ADD_NEW_VIDEO_HERE')}</h5>
                                <p>
                                  {t('PARTNER_VIDEOS_INFO')}
                                </p>
                                <div className="text-center mt-auto">
                                  <button type="button" className="btn btn_red_rp mb-2" onClick={uplodInfoDialog}>{t('UPLOAD_INFO')}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      <Tab eventKey="analysis" title={<span className="section-tab-label"><FaChartBar aria-hidden="true" />{t('ANALYSIS')}</span>} tabClassName="myvideo-tab">
                        <VideoAnalysisSection token={token} goto={goto} reportPathPrefix="/partner-video-analysis" />
                      </Tab>
                      <Tab eventKey="tags" title={<span className="section-tab-label"><FaTag aria-hidden="true" />{t('TAGS')}</span>} tabClassName="myvideo-tab">
                        {
                          selectedVideoForTagging ?
                            <PartnerVideoTagging setValue={setValue} /> :
                            <div className="container pt-5">
                              <div className="row mb-4">
                                <div className="col-12">
                                  <div>
                                    <div className="d-flex" style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                                      <div><h4 className="section_title_neg_rp">{t('TAG_SELECT')}</h4></div>
                                      <div className="ml-auto d-xs-block"><Button className="btn myvideo-action myvideo-action--tag" onClick={showPartnerTags}><FaTag aria-hidden="true" />{t('TAG_CREATE_OR_UPDATE')}</Button></div>
                                    </div>
                                    <hr className="hr_blue" />
                                    <div className="row">
                                      <div className="col-lg-12 mt-sm-2">
                                        {userTags.length > 0 ?
                                          <p>{t('TAG_INFO')}</p>
                                          : <p>{t('NO_TAG_CREATED')}</p>
                                        }
                                        <h3>
                                          <ToggleButtonGroup type="checkbox" className="flex-wrap" onChange={handleTagSelection}>
                                            {userTags.map(t => <ToggleButton key={t.id} style={{ fontFamily: "Arial", margin: 2, backgroundColor: t.color, borderColor: t.color, marginRight: 5, opacity: value && value.includes(t.id) ? 1 : 0.5 }} value={t.id}>{t.label}</ToggleButton>)}
                                          </ToggleButtonGroup>
                                        </h3>
                                        {userTags.length > 0 && taggedUserVideos.length === 0 ?
                                          <p>{t('NO_VIDEO_TAGGED')}</p>
                                          : null}
                                      </div>
                                    </div>
                                    <div className="row" style={{ marginTop: 50 }}>
                                      {
                                        taggedUserVideos.map(v =>
                                        (
                                          <div key={v.videoId} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                            <div className="card video_card_bg_rp skywork-video-content-card skywork-video-content-card--tagged">
                                              <div className="video_card_image" style={styleBackgroundImage(v.partnerId, v.fieldId, v.fieldImage)}>
                                                <div className="videoWrapper" onClick={showVideoTagging(v)}>
                                                  <Fragment>
                                                    <div className="preload h-100 justify-content-start align-items-start">
                                                      <img className="logo-replayer" src={replayerlogoBianco} alt="" />
                                                    </div>
                                                    <div className="preload h-100 justify-content-end align-items-start">
                                                      <img className="logo-partner" src={getPartnerLogo()} alt="" />
                                                    </div>
                                                    <div className="preload h-100 justify-content-center align-items-end">
                                                      <div className="video-description justify-content-center align-items-center">{v.name.substring(0, 60)}</div>
                                                    </div>
                                                  </Fragment>
                                                </div>
                                              </div>
                                              <Formik
                                                enableReinitialize
                                                initialValues={{ videoId: v.videoId, name: v.name, description: v.description, renaming: false }}
                                                onSubmit={values => modifyPartnerPermanentVideo(values.videoId, { name: values.name, description: values.description })}
                                              >
                                                {({
                                                  handleSubmit,
                                                  handleChange,
                                                  values,
                                                  setFieldValue
                                                }) => {
                                                  const rename = formData => {
                                                    handleSubmit(formData);
                                                    setFieldValue('renaming', false);
                                                  };

                                                  const setRenameAndScroll = () => {
                                                    setScrollPosition(getScrollPage());
                                                    setFieldValue('renaming', true);
                                                  };

                                                  if (values.renaming) {
                                                    return (
                                                      <div className="card-body d-flex flex-column">
                                                        <Form onSubmit={rename}>
                                                          <Form.Group>
                                                            <Form.Label>{t('TITLE')}*</Form.Label>
                                                            <Form.Control required name="name" type="text" placeholder={t('TITLE')} maxLength={255} value={values.name || ''} onChange={handleChange} />
                                                          </Form.Group>
                                                          <Form.Group>
                                                            <Form.Label>{t('DESCRIPTION')}</Form.Label>
                                                            <Form.Control name="description" as="textarea" maxLength={255} placeholder={t('DESCRIPTION')} value={values.description || ''} onChange={handleChange} />
                                                          </Form.Group>
                                                          <div className="d-flex flex-row-reverse">
                                                            <button type="button" className="btn myvideo-action myvideo-action--utility ml-1" onClick={() => setFieldValue('renaming', false)}><FaTimes aria-hidden="true" />{t('CANCEL')}</button>
                                                            <Button className="btn myvideo-action myvideo-action--primary ml-1 mr-1" type="submit">{t('SAVE')}</Button>
                                                          </div>
                                                        </Form>
                                                      </div>
                                                    );
                                                  }

                                                  return (
                                                    <Fragment>
                                                      <div className="card-body d-flex flex-column">
                                                        <div className="skywork-video-card-title-box"><h5 className="card-title">{v.name}</h5></div>
                                                        <div className="video_card_star_btn_active" onClick={metadataVideo(v)} />
                                                        <div className="skywork-video-card-description-box">{v.description || t('NO_DESCRIPTION')}</div>
                                                      </div>
                                                      <div className="card_border_bottom_white text-center mt-auto mb-3">
                                                        {Array.isArray(v.cameras) && v.cameras.some(c => c.camera_type === 'flat') && (
                                                          <button
                                                            type="button"
                                                            className="btn myvideo-action myvideo-action--tag mb-3 ml-1 mr-1"
                                                            onClick={showVideoTagging(v)}><FaTag aria-hidden="true" />{t('VIDEO_TAG_CREATE')}
                                                          </button>
                                                        )}
                                                        {/* <button type="button" className="btn btn_blue_rp mb-3 ml-1 mr-1" onClick={showVideoTagging(v)}>{t('VIDEO_TAG_CREATE')}</button> */}
                                                        <button type="button" className="btn myvideo-action myvideo-action--highlight mb-3 ml-1 mr-1" onClick={selectVideoForHighlight(v)}><FaMagic aria-hidden="true" />{t('HIGHLIGHT')}</button>
                                                      </div>
                                                      <ul className="card_video_archive_list_icons mb-3">
                                                        <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={confirmDownloadVideo(v)}><img src={downloadIcon} alt={t('ICON_DOWNLOAD')} /></button></li>
                                                        <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={setRenameAndScroll}><img src={editIcon} alt={t('ICON_CHANGE')} /></button></li>
                                                        <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={confirmDeleteVideo(v.videoId)}><img src={binIcon} alt={t('ICON_DELETE')} /></button></li>
                                                        <p style={{ textAlign: 'right', paddingRight: 10, paddingTop: 10 }}>{(Math.floor(v.filesize) / (1000000000)).toFixed(2)}GB</p>
                                                      </ul>
                                                    </Fragment>
                                                  );
                                                }}
                                              </Formik>
                                            </div>
                                          </div>
                                        ))
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                        }
                        <PartnerTags />
                      </Tab>
                      <Tab eventKey="playlist" title={<span className="section-tab-label"><FaFolderPlus aria-hidden="true" />{t('PLAYLIST')}</span>} tabClassName="myvideo-tab">
                        <div className="row" style={{ marginTop: 50 }}>
                          {
                            playlists.map(v =>
                            (
                              <div key={v.videoId} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                <div className="card video_card_bg_rp skywork-video-content-card skywork-video-content-card--playlist">
                                  <div className="video_card_image" style={styleBackgroundImage(v.partnerId, v.fieldId, v.fieldImage)}>
                                    <div className="videoWrapper" onClick={() => { sendUsageData(usageTypes['playlist'], v.partnerId, v.slotId); window.open(`${Configuration.krpanoPlayerUrl}?slotId=${v.slotId}&playlistId=${v.id}&token=${v.token}`, '_blank'); }}>
                                      <Fragment>
                                        <div className="preload h-100 justify-content-center align-items-center">
                                          <img className="play_arrow" src={playArrowWhite} alt="" />
                                        </div>
                                        <div className="preload h-100 justify-content-start align-items-start">
                                          <img className="logo-replayer" src={replayerlogoBianco} alt="" />
                                        </div>
                                        <div className="preload h-100 justify-content-end align-items-start">
                                          <img className="logo-partner" src={getPartnerLogo()} alt="" />
                                        </div>
                                        <div className="preload h-100 justify-content-center align-items-end">
                                          <div className="video-description justify-content-center align-items-center">{v.name.substring(0, 60)}</div>
                                        </div>
                                      </Fragment>
                                    </div>
                                  </div>
                                  <Formik
                                    enableReinitialize
                                    initialValues={{ id: v.id, name: v.name, description: v.description, renaming: false }}
                                    onSubmit={values => modifyPlaylist(values.id, { name: values.name, description: values.description })}
                                  >
                                    {({
                                      handleSubmit,
                                      handleChange,
                                      values,
                                      setFieldValue
                                    }) => {
                                      const rename = formData => {
                                        handleSubmit(formData);
                                        setFieldValue('renaming', false);
                                      };

                                      const setRenameAndScroll = () => {
                                        setScrollPosition(getScrollPage());
                                        setFieldValue('renaming', true);
                                      };

                                      if (values.renaming) {
                                        return (
                                          <div className="card-body d-flex flex-column">
                                            <Form onSubmit={rename}>
                                              <Form.Group>
                                                <Form.Label>{t('TITLE')}*</Form.Label>
                                                <Form.Control required name="name" type="text" placeholder={t('TITLE')} maxLength={255} value={values.name || ''} onChange={handleChange} />
                                              </Form.Group>
                                              <Form.Group>
                                                <Form.Label>{t('DESCRIPTION')}</Form.Label>
                                                <Form.Control name="description" as="textarea" maxLength={255} placeholder={t('DESCRIPTION')} value={values.description || ''} onChange={handleChange} />
                                              </Form.Group>
                                              <div className="d-flex flex-row-reverse">
                                                <button type="button" className="btn myvideo-action myvideo-action--utility ml-1" onClick={() => setFieldValue('renaming', false)}><FaTimes aria-hidden="true" />{t('CANCEL')}</button>
                                                <Button className="btn myvideo-action myvideo-action--primary ml-1 mr-1" type="submit">{t('SAVE')}</Button>
                                              </div>
                                            </Form>
                                          </div>
                                        );
                                      }

                                      return (
                                        <Fragment>
                                          <div className="card-body d-flex flex-column">
                                            <div className="skywork-video-card-title-box"><h5 className="card-title">{v.name}</h5></div>
                                            <div className="video_card_star_btn_active" onClick={metadataVideo(v)} />
                                            <div className="skywork-video-card-description-box">{v.description || t('NO_DESCRIPTION')}</div>
                                          </div>
                                          <div className="card_border_bottom_white text-center mt-auto mb-3">
                                            <button type="button" className="btn myvideo-action myvideo-action--share mb-3 ml-1 mr-1" onClick={showVideosSharing(v)}><FaShareAlt aria-hidden="true" />{t('SHARE')}</button>
                                            {playlistExportAction(v)}
                                            {v.exportStatus === 'error' ? (
                                              <div className="playlist-export-status playlist-export-status-error">{t('PLAYLIST_GENERATION_FAILED')}</div>
                                            ) : null}
                                            {v.exportStatus === 'pending' || v.exportStatus === 'running' ? (
                                              <div className="playlist-export-status">{t('PLAYLIST_GENERATING')}</div>
                                            ) : null}
                                          </div>
                                          <ul className="card_video_archive_list_icons mb-3">
                                            <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={setRenameAndScroll}><img src={editIcon} alt={t('ICON_CHANGE')} /></button></li>
                                            <li className="card_video_archive_list_icons_item"><button type="button" className="icon_button_rp" onClick={confirmDeletePlaylist(v.id)}><img src={binIcon} alt={t('ICON_DELETE')} /></button></li>
                                            {
                                              v.sharing === sharingType.none ?
                                                <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={privateIcon} alt={t('ICON_USER_PRIVATE')} /><br />{t('PRIVATE')}</li> :
                                                null
                                            }
                                            {
                                              v.sharing === sharingType.public ?
                                                <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={publicIcon} alt={t('ICON_USER_PUBLIC')} /><br />{t('PUBLIC')}</li> :
                                                null
                                            }
                                            {
                                              v.sharing === sharingType.replayer ?
                                                <li className="card_video_archive_list_icons_item d-block" onClick={showVideosSharing(v)}><img src={replayerIcon} alt={t('ICON_USER_REPLAYER')} /><br />{t('REPLAYER_USERS')}</li> :
                                                null
                                            }
                                            <p style={{ textAlign: 'right', paddingRight: 10, paddingTop: 10, whiteSpace: 'nowrap' }}>{(Math.floor(v.filesize) / (1000000000)).toFixed(2)}GB</p>
                                          </ul>
                                        </Fragment>
                                      );
                                    }}
                                  </Formik>
                                </div>
                              </div>
                            ))
                          }
                          <div className="col-md-12 col-lg-4 mb-sm-4 card-group">
                            <div className="empty_slot card video_card_bg_rp">
                              <div className="card_image_pl">
                                <div className="videoWrapper" />
                              </div>
                              <div className="card-body d-flex flex-column">
                                <h5 className="card-title">{t('ADD_NEW_PLAYLIST_HERE')}</h5>
                                <p>
                                  {t('PLAYLIST_INFO')}
                                </p>
                                <div className="text-center mt-auto">
                                  <button type="button" className="btn myvideo-action myvideo-action--utility mb-2" onClick={() => setActiveTab('video')}><FaFilm aria-hidden="true" />{t('MY_VIDEO')}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Fade>
      {
        selectedPermanentVideo === null ?
          null :
          selectedPermanentVideo.analysisMode ?
            <PlayerHighLight video={selectedPermanentVideo} /> :
            <PartnerHighLight video={selectedPermanentVideo} />
      }
      {
        selectedPermanentVideo === null ?
          null :
          <PartnerVideoSharing video={selectedPermanentVideo} />
      }
      <Dialog
        ref={el => {
          dialog = el;
        }} />
      <Modal show={isHighlightPlaylistModalVisible} onHide={() => setHighlightPlaylistModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t('MYVIDEO_CREATE_PLAYLIST_FROM_HIGHLIGHTS')}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{ name: '', description: '' }}
          onSubmit={values => {
            createHighlightPlaylist({
              name: values.name,
              description: values.description,
              highlightItems: selectedHighlights.map(v => ({
                videoId: v.videoId,
                cameraId: getSelectedHighlightCameraId(v)
              }))
            });
            setHighlightPlaylistModalVisible(false);
            clearHighlightPlaylistSelection();
            setActiveTab('playlist');
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <p>{t('MYVIDEO_CREATE_PLAYLIST_HELP')}</p>
                <Form.Group>
                  <Form.Label>{t('MYVIDEO_PLAYLIST_NAME')}*</Form.Label>
                  <Form.Control required name="name" type="text" maxLength={50} placeholder={t('MYVIDEO_PLAYLIST_NAME_PLACEHOLDER')} value={values.name} onChange={handleChange} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t('DESCRIPTION')}</Form.Label>
                  <Form.Control name="description" as="textarea" maxLength={255} placeholder={t('MYVIDEO_OPTIONAL_DESCRIPTION')} value={values.description} onChange={handleChange} />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button className="btn myvideo-action myvideo-action--utility" onClick={() => setHighlightPlaylistModalVisible(false)}><FaTimes aria-hidden="true" />{t('CANCEL')}</Button>
                <Button className="btn myvideo-action myvideo-action--playlist" type="submit"><FaFolderPlus aria-hidden="true" />{t('MYVIDEO_CREATE_PLAYLIST')}</Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      <Modal className="myvideo-highlight-guide-modal" show={isHighlightGuideModalVisible} onHide={() => setHighlightGuideModalVisible(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{t('MYVIDEO_HIGHLIGHT_GUIDE_TITLE')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="myvideo-highlight-guide-intro">{t('MYVIDEO_HIGHLIGHT_GUIDE_INTRO')}</p>
          <div className="myvideo-highlight-guide-grid">
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_GUIDE_CREATE_HIGHLIGHT')}</h6>
              <p>{t('MYVIDEO_GUIDE_CREATE_HIGHLIGHT_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_GUIDE_CREATE_FOLDER')}</h6>
              <p>{t('MYVIDEO_GUIDE_CREATE_HIGHLIGHT_FOLDER_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_GUIDE_SHARE_HIGHLIGHTS')}</h6>
              <p>{t('MYVIDEO_GUIDE_SHARE_HIGHLIGHT_HELP')}</p>
              <p>{t('MYVIDEO_GUIDE_SHARE_FOLDER_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_GUIDE_CREATE_PLAYLIST')}</h6>
              <p>{t('MYVIDEO_GUIDE_CREATE_PLAYLIST_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_GUIDE_DOWNLOAD_PLAYLIST')}</h6>
              <p>{t('MYVIDEO_GUIDE_DOWNLOAD_PLAYLIST_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_DELETE_FOLDER')}</h6>
              <p>{t('MYVIDEO_DELETE_HIGHLIGHT_FOLDER_HELP')}</p>
            </div>
          </div>
          <div className="myvideo-highlight-guide-extra"><strong>{t('MYVIDEO_GUIDE_REMEMBER')}</strong><span>{t('MYVIDEO_GUIDE_FLAT_CAMERA_NOTE')}</span></div>
          <div className="myvideo-highlight-guide-note">{t('MYVIDEO_GUIDE_HIGHLIGHTS_PRESERVED')}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn_red_rp" onClick={() => setHighlightGuideModalVisible(false)}>{t('UNDERSTOOD')}</Button>
        </Modal.Footer>
      </Modal>
      <Modal className="myvideo-highlight-guide-modal" show={isVideoGuideModalVisible} onHide={() => setVideoGuideModalVisible(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{t('MYVIDEO_VIDEO_GUIDE_TITLE')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="myvideo-highlight-guide-intro">{t('MYVIDEO_VIDEO_GUIDE_INTRO')}</p>
          <div className="myvideo-highlight-guide-grid">
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_GUIDE_CREATE_HIGHLIGHT')}</h6>
              <p>{t('MYVIDEO_VIDEO_GUIDE_CREATE_HIGHLIGHT_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_VIDEO_GUIDE_CREATE_TAG')}</h6>
              <p>{t('MYVIDEO_VIDEO_GUIDE_CREATE_TAG_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_VIDEO_GUIDE_CREATE_FOLDER')}</h6>
              <p>{t('MYVIDEO_VIDEO_GUIDE_CREATE_FOLDER_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_PARTNER_SHARE_DOWNLOAD')}</h6>
              <p>{t('MYVIDEO_PARTNER_SHARE_DOWNLOAD_HELP')}</p>
            </div>
            <div className="myvideo-highlight-guide-item">
              <h6>{t('MYVIDEO_DELETE_FOLDER')}</h6>
              <p>{t('MYVIDEO_DELETE_VIDEO_FOLDER_HELP')}</p>
            </div>
          </div>
          <div className="myvideo-highlight-guide-extra"><strong>{t('MYVIDEO_ORGANIZE_NOT_SHARE')}</strong><span>{t('MYVIDEO_ORGANIZE_NOT_SHARE_HELP')}</span></div>
          <div className="myvideo-highlight-guide-note">{t('MYVIDEO_VIDEO_GUIDE_FOLDER_NOTE')}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn_red_rp" onClick={() => setVideoGuideModalVisible(false)}>{t('UNDERSTOOD')}</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={isStorageModalVisible} onHide={hideStorageModal}>
        <Modal.Header closeButton>
          <Modal.Title>{t('MY_VIDEO_MANAGE_SPACE')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Fragment>
            {t('MY_VIDEO_CHOOSE_SPACE')}
            <Formik
              initialValues={{ storageType: selectableStorageType }}
              onSubmit={changeStorageType}
            >
              {({
                handleSubmit,
                setFieldValue,
                values
              }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <Form.Group>
                      <Form.Check required name="storageType" type="radio" label={t('STORAGE_PRICE_S', { price: storagePrices.s })} checked={values.storageType === "s"} onChange={() => setFieldValue('storageType', "s")} />
                      <Form.Check required name="storageType" type="radio" label={t('STORAGE_PRICE_M', { price: storagePrices.m })} checked={values.storageType === "m"} onChange={() => setFieldValue('storageType', "m")} />
                      <Form.Check required name="storageType" type="radio" label={t('STORAGE_PRICE_L', { price: storagePrices.l })} checked={values.storageType === "l"} onChange={() => setFieldValue('storageType', "l")} />
                      <Form.Check required name="storageType" type="radio" label={t('STORAGE_PRICE_XL', { price: storagePrices.xl })} checked={values.storageType === "xl"} onChange={() => setFieldValue('storageType', "xl")} />
                      <Form.Check required name="storageType" type="radio" label={t('STORAGE_PRICE_XXL', { price: storagePrices.xxl })} checked={values.storageType === "xxl"} onChange={() => setFieldValue('storageType', "xxl")} />
                      <Form.Check required name="storageType" type="radio" label={t('STORAGE_PRICE_XXXL', { price: storagePrices.xxxl })} checked={values.storageType === "xxxl"} onChange={() => setFieldValue('storageType', "xxxl")} />
                    </Form.Group>
                    <Button type="submit" variant="secondary" style={{ marginBottom: 50 }}>{t('SAVE')}</Button>
                  </Form>
                );
              }}
            </Formik>
          </Fragment>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={hideStorageModal}>
            {t('CLOSE_BUTTON')}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={isPartnerVideoCreationVisible} onHide={hidePartnerVideoCreationModal}>
        <Modal.Header closeButton>
          <Modal.Title>{t('ADD_PARTNER_VIDEO')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Fragment>
            <Formik
              enableReinitialize
              initialValues={{ title: null, description: null }}
              onSubmit={createPartnerVideo}
            >
              {({
                handleSubmit,
                setFieldValue,
                handleChange,
                values
              }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <Form.Group>
                      <Form.Label>{t('TITLE')}</Form.Label>
                      <Form.Control required name="title" placeholder={t('TITLE')} type="text" maxLength="60" value={values.title || ''} onChange={handleChange} />
                      <Form.Text>{t('CHARACTERS_LIMIT', { limit: 60 })}</Form.Text>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>{t('DESCRIPTION')}</Form.Label>
                      <Form.Control required name="description" placeholder={t('DESCRIPTION')} type="text" maxLength="250" value={values.description || ''} onChange={handleChange} />
                      <Form.Text>{t('CHARACTERS_LIMIT', { limit: 250 })}</Form.Text>
                    </Form.Group>
                    <Button type="submit" variant="secondary" style={{ marginBottom: 50 }}>{t('SAVE')}</Button>
                  </Form>
                );
              }}
            </Formik>
          </Fragment>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={hidePartnerVideoCreationModal}>
            {t('CLOSE_BUTTON')}
          </Button>
        </Modal.Footer>
      </Modal>
      {selectedPartnerVideo ?
        <Modal show={isPartnerVideoEditModalVisible} onHide={hidePartnerVideoEditModal}>
          <Modal.Header closeButton>
            <Modal.Title>{t('PARTNER_VIDEO_EDIT')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Fragment>
              <Formik
                initialValues={{ title: selectedPartnerVideo.title, description: selectedPartnerVideo.description, videoName: selectedPartnerVideo.videoName, videoPrice: selectedPartnerVideo.videoPrice, videoCost: selectedPartnerVideo.videoCost, uploadFilename: selectedPartnerVideo.uploadFilename, uploadDate: selectedPartnerVideo.uploadDate, filesize: selectedPartnerVideo.filesize, public: selectedPartnerVideo.public, rtv: selectedPartnerVideo.rtv }}
                onSubmit={values => editPartnerVideo(selectedPartnerVideo.videoId, values, selectedPlayers)}
              >
                {({
                  handleSubmit,
                  setFieldValue,
                  handleChange,
                  values
                }) => {
                  const imagePartnerVideo = (selectedPartnerVideo.coverImage || []).map(f => {
                    return {
                      source: f,
                      options: {
                        type: 'local'
                      }
                    };
                  });
                  return (
                    <Form onSubmit={handleSubmit}>
                      <Form.Group>
                        <div style={{ textAlign: 'right' }}>
                          <p>id: {selectedPartnerVideo.videoId}</p>
                        </div>
                        <Form.Label>{t('TITLE')}</Form.Label>
                        <Form.Control required name="title" placeholder={t('TITLE')} type="text" maxLength="60" value={values.title || ''} onChange={handleChange} />
                        <Form.Text>{t('CHARACTERS_LIMIT', { limit: 60 })}</Form.Text>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>{t('DESCRIPTION')}</Form.Label>
                        <Form.Control required name="description" placeholder={t('DESCRIPTION')} type="text" maxLength="250" value={values.description || ''} onChange={handleChange} />
                        <Form.Text>{t('CHARACTERS_LIMIT', { limit: 250 })}</Form.Text>
                      </Form.Group>
                      {values.videoName ?
                        <div>
                          <Form.Group>
                            <Form.Label>{t('FILE_NAME')}</Form.Label>
                            <Form.Control name="uploadFilename" type="text" value={values.uploadFilename || ''} readOnly />
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>{t('FILE_SIZE')}</Form.Label>
                            <Form.Control name="filesize" type="text" value={(Math.floor(values.filesize) / (1000000000)).toFixed(2) + ' GB' || ''} readOnly />
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>{t('UPLOAD_DATE')}</Form.Label>
                            <Form.Control name="uploadDate" type="text" value={values.uploadDate.replace(/T.*/, '').split('-').reverse().join('/') || ''} readOnly />
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>{t('VIDEO_COST')}</Form.Label>
                            <Form.Control name="videoCost" type="text" value={values.videoCost.toFixed(2).replace('.', ',') || ''} readOnly />
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>{t('VIDEO_PRICE')}*</Form.Label>
                            <Form.Control required name="videoPrice" type="number" placeholder={t('VIDEO_PRICE')} min={values.videoCost} step={0.01} value={values.videoPrice} onChange={handleChange} />
                          </Form.Group>
                          {profile.rtvChannels.filter(c => c.type === 1).length ?
                            <Form.Group>
                              <Form.Check name="rtv" type="checkbox" label={t('PUBLISH_ON_RTV')} checked={values.rtv} onChange={() => setFieldValue('rtv', !values.rtv)} />
                            </Form.Group>
                            : null}
                          <Form.Group>
                            <Form.Check name="videoSellPermission" type="checkbox" label={t('SALABLE_VIDEO')} checked={values.public !== null} onChange={() => setFieldValue('public', values.public !== null ? null : true)} />
                          </Form.Group>
                        </div>
                        : null}
                      {values.public !== null ?
                        <Form.Group>
                          <Form.Check required name="public" type="radio" label={t('PUBLIC')} checked={values.public} onChange={() => setFieldValue('public', true)} />
                          <Form.Check required name="public" type="radio" label={t('PRIVATE')} checked={!values.public} onChange={() => setFieldValue('public', false)} />
                        </Form.Group>
                        : null}
                      {values.public === false ?
                        <Form.Group>
                          <Form.Label>{t('PLAYERS_SELECTION')}</Form.Label>
                          {renderPlayer(selectedPlayers)}
                          <Button variant="secondary" onClick={showPlayersModal}>{t('ADD_PLAYER')}</Button>
                        </Form.Group>
                        : null}
                      <Form.Label>{t('VIDEO_COVER')}</Form.Label>
                      <FilePond
                        files={imagePartnerVideo}
                        server={
                          {
                            url: `${Configuration.apiEndPoint}/`,
                            process: {
                              url: `./video_partners/${selectedPartnerVideo.videoId}/images`,
                              ondata: formData => {
                                formData.append('image_type', imageTypes.partnerVideoCover);
                                return formData;
                              }
                            },
                            revert: `./video_partners/${selectedPartnerVideo.videoId}/images`,
                            restore: `./video_partners/${selectedPartnerVideo.videoId}/images`,
                            fetch: `./video_partners/${selectedPartnerVideo.videoId}/images`,
                            load: `./video_partners/${selectedPartnerVideo.videoId}/images?load=`,
                            headers: { Authorization: `Bearer ${token}` },
                            remove: (source, load) => {
                              removeFile(source, selectedPartnerVideo.videoId, selectedPartnerVideo, selectedPartnerVideo);
                              load();
                            }
                          }
                        }
                      />
                      <Button type="submit" variant="secondary" style={{ marginBottom: 50 }}>{t('SAVE')}</Button>
                    </Form>
                  );
                }}

              </Formik>
            </Fragment>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={hidePartnerVideoEditModal}>
              {t('CLOSE_BUTTON')}
            </Button>
          </Modal.Footer>
        </Modal>
        : null}
      {isPlayersModalVisible ?
        <Modal show={isPlayersModalVisible} onHide={hidePlayersModal}>
          <Modal.Header closeButton>
            <Modal.Title>{t('ADD_PLAYER')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              enableReinitialize
              initialValues={{ selectedPlayers }}
              onSubmit={values => setSelectedPlayers(values.selectedPlayers)}
            >
              {({
                handleSubmit,
                setFieldValue,
                handleChange,
                values
              }) => {

                const addInvitedPlayer = (player) => {
                  let alreadyInvited = false;
                  values.selectedPlayers.forEach(p => {
                    if (p.uid === player.uid) alreadyInvited = true;
                  });
                  if (!alreadyInvited) values.selectedPlayers.push(player);
                  setSelectedPlayer({});
                  values.playerName = "";
                  values.playerSurname = "";
                  values.playerNickname = "";
                  hidePlayersModal();
                };

                return (
                  <Form onSubmit={handleSubmit}>
                    <Fragment>
                      <p>{t('THREE_CHAR_MINIMUM')}</p>
                      <Form.Group style={{ display: 'flex', flexDirection: 'row' }} required>
                        <Form.Control name="playerNickname" style={{ maxWidth: 150 }} placeholder={t('NICKNAME')} type="text" maxLength="25" minLength="3" value={values.playerNickname || ""} onChange={handleChange} />
                        <Form.Control name="playerName" style={{ maxWidth: 150 }} placeholder={t('NAME')} type="text" maxLength="25" minLength="3" value={values.playerName || ""} onChange={handleChange} />
                        <Form.Control name="playerSurname" style={{ maxWidth: 150 }} placeholder={t('SURNAME')} type="text" maxLength="25" minLength="3" value={values.playerSurname || ""} onChange={handleChange} />
                      </Form.Group>
                      <Form.Group style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Form.Check name="playerAffiliate" type="checkbox" label={t('PLAYER_AFFILIATE', { partner: profile.name })} checked={values.playerAffiliate === true} onChange={() => setFieldValue('playerAffiliate', !values.playerAffiliate)} />
                        <Button disabled={!((values.playerNickname && values.playerNickname.length > 2) || (values.playerName && values.playerName.length > 2) || (values.playerSurname && values.playerSurname.length > 2))} variant="secondary" onClick={() => searchPlayers(values.playerNickname, values.playerName, values.playerSurname, values.playerAffiliate)}>{t('SEARCH')}</Button>
                      </Form.Group>
                      <Form.Group style={{ display: 'flex', flexDirection: 'column' }}>
                        {playersList.map(p =>
                          renderPlayerSearch(p)
                        )}
                        <Button style={{ maxWidth: 100 }} disabled={selectedPlayer.uid === undefined} variant="secondary" onClick={() => addInvitedPlayer(selectedPlayer)}>{t('SELECT')}</Button>
                      </Form.Group>
                    </Fragment>
                  </Form>
                )
              }}
            </Formik>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={hidePlayersModal}>
              {t('CLOSE_BUTTON')}
            </Button>
          </Modal.Footer>
        </Modal>
        : null}
    </Fragment>
  );
};

PartnerVideo.propTypes = {
  token: PropTypes.string,
  prifile: PropTypes.object,
  permanentVideos: PropTypes.array,
  storagePrices: PropTypes.object,
  selectVideoForHighlight: PropTypes.func.isRequired,
  selectVideoForAnalysis: PropTypes.func.isRequired,
  selectedPermanentVideo: PropTypes.object,
  deletePartnerPermanentVideo: PropTypes.func.isRequired,
  deletePlaylist: PropTypes.func.isRequired,
  modifyPlaylist: PropTypes.func.isRequired,
  modifyPartnerPermanentVideo: PropTypes.func.isRequired,
  showVideosSharing: PropTypes.func.isRequired,
  showPartnerTags: PropTypes.func.isRequired,
  userTags: PropTypes.array,
  myVideoActiveTab: PropTypes.string,
  setActiveTab: PropTypes.func.isRequired,
  showVideoTagging: PropTypes.func.isRequired,
  selectedVideoForTagging: PropTypes.object,
  searchTaggedVideo: PropTypes.func.isRequired,
  taggedUserVideos: PropTypes.array,
  changeStorageType: PropTypes.func.isRequired,
  isStorageModalVisible: PropTypes.bool.isRequired,
  showStorageModal: PropTypes.func.isRequired,
  hideStorageModal: PropTypes.func.isRequired,
  playlists: PropTypes.array.isRequired,
  highlightFolders: PropTypes.array.isRequired,
  videoFolders: PropTypes.array.isRequired,
  getPartnerHighlightFolders: PropTypes.func.isRequired,
  createPartnerHighlightFolder: PropTypes.func.isRequired,
  deletePartnerHighlightFolder: PropTypes.func.isRequired,
  movePartnerHighlightToFolder: PropTypes.func.isRequired,
  getPartnerVideoFolders: PropTypes.func.isRequired,
  createPartnerVideoFolder: PropTypes.func.isRequired,
  deletePartnerVideoFolder: PropTypes.func.isRequired,
  movePartnerVideoToFolder: PropTypes.func.isRequired,
  createHighlightPlaylist: PropTypes.func.isRequired,
  exportPlaylist: PropTypes.func.isRequired,
  partnerVideos: PropTypes.array.isRequired,
};

PartnerVideo.defaultProps = {
  token: null,
  profile: null,
  permanentVideos: [],
  storagePrices: {},
  selectedPermanentVideo: null,
  userTags: [],
  myVideoActiveTab: "video",
  selectedVideoForTagging: null,
  taggedUserVideos: [],
  isStorageModalVisible: false,
  playlists: [],
  highlightFolders: [],
  videoFolders: [],
  partnerVideos: [],
};

export default PartnerVideo;
